import React from "react";
import {
    StyleSheet,
    // ToastAndroid,
    Alert,
    Text,
    View,
    ImageBackground,
    ScrollView,
    TouchableOpacity,
    TextInput,
    Image,
    }
    from 'react-native';

import * as Linking from 'expo-linking';

import {RFValue} from "react-native-responsive-fontsize";



import { Feather } from '@expo/vector-icons';
import { FontAwesome5 } from '@expo/vector-icons';
import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from "axios";

// import Toast from 'react-native-tiny-toast';
import Config from "../components/Config";

import ToastNotification from 'react-native-toast-notification'

const Login = ({navigation})=>{


    let [password,setPassword] = React.useState('');
    let [email,setEmail] = React.useState('');
    let [disable,setDisable] = React.useState(false);

    let [toast,setToast] = React.useState(false);


    const ajax = async ()=>{

        setToast('Loading ...');


        setDisable(true);

        let formData = new FormData();
        formData.append('email', email);
        formData.append('password', password);


        // Toast.showLoading('Sending Data ... ');
        let res = await axios.post(
            `${Config.base}/api/v1/login/mobile`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }
        );
        setDisable(false);
        setToast(false);
        // Toast.hide('');
        if(res.data.status == 200){
            await AsyncStorage.setItem('token', res.data.token);


            navigation.reset({
                index: 0,
                routes: [{ name: "Home" }],
            });
        }else{
            // Alert.alert('Error', res.data.message, [
            //     {
            //         text: 'Close',
            //         onPress: () => {
            //         },
            //         style: 'default',
            //     },
            // ]);
            // Toast.show(res.data.message);



            setToast(res.data.message);

            const timeoutId = setTimeout(() => {
                setToast(false);
            }, 3000);
            // ToastAndroid.show(res.data.message, ToastAndroid.SHORT);
        }




    }


    return (
        <View style={{flex : 1}}>
            <ImageBackground
                source={{uri:'https://metamax.network/public/appBg.jpg'}}
               resizeMode="cover" style={{flex : 1,justifyContent : 'center'}}>

                <View style={{alignItems : 'center', justifyContent : 'center' , margin : RFValue(0),}}>
                    <Image
                        resizeMode={'stretch'}
                        fadeDuration={999}
                        style={{
                            width : 160,
                            height :35,
                            marginVertical : 10,
                            borderRadius : 15,
                            backgroundColor : 'rgba(0,0,0,0.1)',
                            padding : RFValue(10),
                        }}

                        source={{uri : 'https://metamax.network/frontAssets/assets/images/logo/logo-dark.png'}}

                    />

                    <View style={styles.inputbox}>
                        <TextInput
                            value={email}
                            onChangeText={setEmail}
                            placeholder={'Email'}
                            placeholderTextColor={'#FFF'}
                            style={
                            {
                                flex : 1 ,
                                paddingHorizontal : RFValue(15),
                                color : '#FFF',

                            }}
                        />
                        <Feather name="user" style={{margin : RFValue(10)}} size={RFValue(15)} color="#FFF" />

                    </View>
                    <View style={styles.inputbox}>
                        <TextInput
                            value={password}
                            onChangeText={setPassword}
                            secureTextEntry={true}
                            placeholder={'Password'}
                            placeholderTextColor={'#FFF'}
                            style={
                                {
                                    flex : 1 ,
                                    paddingHorizontal : RFValue(15),
                                    color : '#FFF',

                                }}
                        />
                        <FontAwesome5 name="key" style={{margin : RFValue(10)}} size={RFValue(15)} color="#FFF" />


                    </View>
                    <TouchableOpacity onPress={()=>navigation.navigate('Register')}>
                        <Text style={styles.registertext}>Not Register ?</Text>
                    </TouchableOpacity>

                    <View style={{justifyContent : 'center',alignItems : 'center'  , width : '80%'}}>
                        <TouchableOpacity disabled={disable}  onPress={ajax}>
                            <View style={styles.btn}>
                                <Text  style={styles.btntext}> Login </Text>
                            </View>
                        </TouchableOpacity>
                    </View>
                </View>
                {toast.length &&
                    <ToastNotification
                        // textStyle={{ color: 'red' }}
                        // style={{ backgroundColor: 'yellow' }}
                        text={toast}
                        // duration={99999999999}
                        isTop={true}
                        style={{ padding: RFValue(10) }}
                    />
                }
            </ImageBackground>
        </View>
    );
}


const styles = StyleSheet.create({

    inputbox : {
        flexDirection : 'row',
        justifyContent : 'space-around',
        borderColor : '#FFF',
        borderWidth : 1,
        borderRadius : RFValue(10),
        width : '80%',
        marginVertical : RFValue(10),

    },
    registertext : {
        fontFamily : 'novaria',
        color : '#FFF',
        fontSize : RFValue(14),
        marginHorizontal : RFValue(10),
    },
    btn : {
        width : '40%',
        justifyContent : "center",
        alignItems: 'center',
        paddingHorizontal : RFValue(20),
        borderRadius : RFValue(5),
        backgroundColor : '#07bdad',
        marginHorizontal : RFValue(3),
        marginVertical : RFValue(15),
        fontSize : RFValue(14)


    },

    btntext : {
        color : '#FFF',
        fontFamily : 'novaria',
        fontSize : RFValue(18),
    },


});


export default Login;
